var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "url-[#1423]",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.388 3.22665C5.05463 1.63939 7.76502 1.63939 9.43164 3.22665L10.9423 4.66537L12.4529 3.22665L10.9423 1.78796C8.43915 -0.595986 4.3805 -0.595986 1.87735 1.78796C-0.625785 4.1719 -0.625785 8.03728 1.87735 10.4212L3.388 11.8599L4.89865 10.4212L3.388 8.9825C1.72138 7.39524 1.72138 4.81391 3.388 3.22665ZM19.1226 9.57876L17.612 8.13903L16.1013 9.57876L17.612 11.0175C19.2775 12.6037 19.2775 15.1861 17.612 16.7733C15.9454 18.3596 13.2339 18.3596 11.5684 16.7733L10.0577 15.3336L8.54599 16.7733L10.0577 18.212C12.5608 20.596 16.6195 20.596 19.1226 18.212C21.6258 15.8281 21.6258 11.9627 19.1226 9.57876ZM5.65396 3.94601L16.8567 14.6142L15.345 16.054L4.14331 5.38473L5.65396 3.94601Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.f3f27a4c41c31b0a598f913c966c5bcb.svg";
export { ForwardRef as ReactComponent };